import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { VoucherClickedEventSchema } from '../../schemas/voucher/VoucherClickedEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { EVENT_CATEGORY } from '../../constants/EventHelper'

export interface VoucherClickedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  OFFER_ID: string
  OFFER_TYPE: string
  OFFER_SAP_REFERENCE?: string
  VOUCHER_NAME: string
  VOUCHER_CODE: string
  VOUCHER_POSITION?: number
  STORE_ID_SAP?: string
  STORE_ID_DBP?: string
  STORE?: string
}

export class VoucherClickedEvent extends AnalyticsEvent {
  constructor(params: VoucherClickedEventParams) {
    super(VoucherClickedEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackVoucherClickedEvent(
  voucherClickedParams: VoucherClickedEventParams,
): Promise<void> {
  try {
    const config = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_THREE) || {}
    const { isEnabled = false } = config
    if (isEnabled) {
      const commonParams = getCommonParams()
      const params: VoucherClickedEventParams = {
        ...commonParams,
        ...voucherClickedParams,
        SCREEN_NAME: voucherClickedParams.SCREEN_NAME ?? commonParams.SCREEN_NAME,
        BUSINESS_VERTICAL: voucherClickedParams.BUSINESS_VERTICAL,
        EVENT_CATEGORY: EVENT_CATEGORY.VOUCHER,
      }
      new VoucherClickedEvent(params).track()
    }
  } catch (error) {
    console.error('Error tracking VoucherClickedEvent:', error)
  }
}
